import axios from 'axios';
import Cookies from "js-cookie";
import { userDataTypes } from '../types/auth.types';
import { BACKEND_URL, REACT_APP_ENV } from "./apiConfig";
import { log } from "../utils/logger";

export { BACKEND_URL, REACT_APP_ENV };


/**
* Logs in a user with email and password.
* Sets the JWT token cookie upon successful login.
*
* @param {string} email - User's email address.
* @param {string} password - User's password.
* @returns {Promise<string>} Promise resolving to a success message.
* @throws Will throw an error if the login request fails.
*/
export const login = async (email: string, password: string): Promise<string> => {
    const response = await axios.post<string>(`${BACKEND_URL}/eshop/auth/login`, { email, password });
    // Set jwt token cookie
    Cookies.set("CatermatAuthToken", response.data, {
        expires: 14,
        secure: window.location.protocol === "https:",
    })
    // Return the token
    return "Login successfull";
}
/**
* Verifies the current user's authentication token.
* Retrieves the user's data if the token is valid.
*
* @returns {Promise<userDataTypes>} Promise resolving to user data.
* @throws Will throw an error if the verification request fails.
*/
export const verify = async () => {
    const token = Cookies.get("CatermatAuthToken");
    const response = await axios.get<userDataTypes>(`${BACKEND_URL}/eshop/auth/verify`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    // Return the users data
    return response.data;
}
/**
* Sends a password reset request for the specified email.
*
* @param {string} email - User's email address for password reset.
* @returns {Promise<string>} Promise resolving to a response message.
* @throws Will throw an error if the reset request fails.
*/
export const resetPass = async (email: string): Promise<boolean> => {
    const res = await axios.post(`${BACKEND_URL}/eshop/auth/reset`, { email });
    return res.status >= 200 && res.status < 300;
};


export const createAccount = async (otp: string, password: string) => {
    try {
        const response = await axios.post(`${BACKEND_URL}/eshop/auth/invites/confirm`,
            {
                otp: otp,
                password: password
            }
        );
        
        return {
            success: true,
            data: response.data
        };
    } catch (error: any) {
        return {
            success: false,
            error: error.response?.data || error.message,
            info: error
        };
    }
}

